<div class="modal" tabindex="-1" id="modalAddSubAccount">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title label">Modifica sottoconto</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (blur)="goBack()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body position-relative">
        <div *ngIf="isLoading" class="spinner-overlay">
          <div class="text-center">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
          </div>
        </div>
        <div class="commission-form">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <label for="name">Nome</label>
                <input
                  pInputText
                  id="name"
                  type="text"
                  formControlName="name"
                  placeholder="Inserisci"
                  class="commission-input my-2"
                />
              </div>
              <div class="col-lg-6 col-md-12">
                <label for="code">Codice</label>
                <input
                  pInputText
                  id="code"
                  type="text"
                  formControlName="code"
                  placeholder="Inserisci"
                  class="commission-input my-2"
                />
              </div>
              <div class="col-lg-6 col-md-12">
                <label for="type">Modalità</label>
                <p-dropdown
                  id="type"
                  formControlName="type"
                  [options]="typeOptions ?? []"
                  filter="true"
                  filterBy="description"
                  optionLabel="description"
                  placeholder="Seleziona..."
                  styleClass="commission-dropdown my-2  "
                  showClear="true"
                  (onChange)="this.onChangeType()"
                  (onClear)="this.onClearType()"
                  [ngClass]="{ 'ng-dirty': getDirty(form, 'type') }"
                ></p-dropdown>
              </div>
              <div class="col-lg-6 col-md-12">
                <label for="node">Nodo</label>
                <input
                  pInputText
                  id="node"
                  type="text"
                  formControlName="node"
                  placeholder="Inserisci"
                  class="commission-input my-2"
                />
              </div>
              <div class="col-lg-6 col-md-12">
                <label for="account">Conto</label>
                <p-dropdown
                  id="account"
                  formControlName="account"
                  [options]="accountOptions ?? []"
                  filter="true"
                  filterBy="description"
                  optionLabel="description"
                  [readonly]="this.form.get('type')?.value === null"
                  placeholder="Seleziona..."
                  styleClass="commission-dropdown my-2  "
                  showClear="true"
                  [ngClass]="{
                    'ng-dirty': getDirty(form, 'account'),
                    'dropdown-disabled': this.form.get('type')?.value === null
                  }"
                ></p-dropdown>
              </div>
              <div class="col-lg-6 col-md-12">
                <label class="col-12" for="dirCollection"
                  >Incasso Direzionale</label
                >
                <p-inputSwitch class="col-12" formControlName="dirCollection" />
              </div>
              <div
                *ngIf="this.userInfo?.isDirectionalUser"
                class="col-lg-6 col-md-12"
              >
                <label for="agency">Agenzia</label>
                <p-autoComplete
                  styleClass="autocomplete-dropdown my-2"
                  formControlName="agency"
                  showClear="true"
                  [dropdown]="true"
                  [suggestions]="filteredValues"
                  (completeMethod)="filterValues($event)"
                  placeholder="Seleziona..."
                  showEmptyMessage="false"
                  field="description"
                  [ngClass]="{ 'ng-dirty': getDirty(form, 'agency') }"
                />
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-center">
              <button class="btn btn-primary mx-3 my-4" type="submit">
                <strong>Modifica</strong>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
